import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { authService } from "@shared/ui";
import { useTranslation } from "react-i18next";

type FormValues = {
  email: string;
};

const ForgotPasswordForm: React.FC<{setResetPassword: (value: boolean) => void}> = ({setResetPassword}) => {
  const { t } = useTranslation();
  const [success, setSuccess] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>();

  const onSubmit = async (data: FormValues) => {
    try {
      await authService.forgotPassword(data.email);
      setSuccess(true);
    } catch (e) {
      console.error(e);
    }
  };

  if (success) {
    return <p>{t("forgotPassword.successMessage")}</p>;
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div>
        <input
          type="email"
          placeholder={t("forgotPassword.emailPlaceholder")}
          {...register("email", {
            required: t("forgotPassword.errors.emailRequired"),
            pattern: {
              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              message: t("forgotPassword.errors.emailInvalid"),
            },
          })}
        />
        {errors.email && <span className="error">{errors.email.message}</span>}
      </div>
      <div className="text-right">
        <button type="button" className="btn-text" onClick={() => setResetPassword(false)}>{t("forgotPassword.buttons.backToLogin")}</button>
      </div>

      <input type="submit" disabled={isSubmitting} value={isSubmitting ? t("forgotPassword.submit.sending") : t("forgotPassword.submit.send")} />
    </form>
  );
};

export default ForgotPasswordForm;